import Layout from 'antd/lib/layout';
import styled from 'styled-components';

const Footer = styled(Layout.Footer)`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 20;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.5rem 1rem;
  background-color: #f7f7f7;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

const Img = styled.img`
  height: 1.125rem;
`;

const Social = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 2rem);
  gap: 0.5rem;
`;

const SocialLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  color: #fff;
  background-color: #24bba7;
  border-radius: 100%;

  &:hover {
    background-color: #1aa592;
  }
`;

const Text = styled.p`
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export default {
  Footer,
  Img,
  Social,
  SocialLink,
  Text,
};
